import PropTypes from "prop-types";

export function CustomComingSoonCard({ children }) {
  return (
    <div className="relative group/soon cursor-not-allowed rounded-lg bg-white shadow border border-gray-200">
      <div className="opacity-50 pointer-events-none transition-opacity duration-300 group-hover/soon:opacity-0">
        {children}
      </div>
      <div className="absolute inset-0 rounded-lg flex items-center justify-center bg-white opacity-0 group-hover/soon:opacity-100 transition-opacity duration-300">
        <span className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
          Coming Soon
        </span>
      </div>
    </div>
  );
}

CustomComingSoonCard.propTypes = {
  children: PropTypes.node.isRequired,
};
